import { render } from "./StayHome.vue?vue&type=template&id=411753fc"
import script from "./StayHome.vue?vue&type=script&lang=js"
export * from "./StayHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__